import request from "../utils/request";

/** 获取前端顶部导航已开启菜单 */
export const getPublicNavMenus = () => {
  return request({
    url: "/user/public/nav/menus",
    method: "get",
  });
};
